export const environment = {
  production: false,
  TENANT_ID: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com',
  CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://dev.subprod.newlios.toyota.com',
  SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
  CLOUDFRONT: 'https://d3jkgs9vp5q4j6.cloudfront.net',
  log_level: 'debug',
  ADMIN_DS_URI: 'https://dev.api.subprod.newlios.toyota.com/admin/graphql',
  APM_DS_URI: 'https://api.sit.lios.toyota.com/apm/graphql',
  BILLING_DS_URI: 'https://dev.api.subprod.newlios.toyota.com/billing/graphql',
  OPERATION_DS_URI : "https://dev.api.subprod.newlios.toyota.com/operations/graphql",
  FILEDOWNLOAD_PDF_URI : "https://filedownload.dev.lios.toyota.com",
  MAINTENANCE_DS_URI : "https://dev.api.subprod.newlios.toyota.com/maintenance/graphql",
  manifest: {
    admin: 'https://dev.admin.subprod.newlios.toyota.com/remoteEntry.js',
    apm: 'https://dev.apm.subprod.newlios.toyota.com/remoteEntry.js',
    bm: 'https://dev.bm.subprod.newlios.toyota.com/remoteEntry.js',
    lcm: 'https://dev.lcm.subprod.newlios.toyota.com/remoteEntry.js',
    cm: 'https://dev.cm.subprod.newlios.toyota.com/remoteEntry.js',
    drc: 'https://dev.drc.subprod.newlios.toyota.com/remoteEntry.js',
    gc: 'https://dev.generalcosts.subprod.newlios.toyota.com/remoteEntry.js',
    ec: 'https://dev.ec.subprod.newlios.toyota.com/remoteEntry.js',
    lpi: 'https://dev.lpi.subprod.newlios.toyota.com/remoteEntry.js',
    maintenance: 'https://dev.maintenance.subprod.newlios.toyota.com/remoteEntry.js',
    mshell: 'https://dev.mshell.subprod.newlios.toyota.com/remoteEntry.js',
    bshell: 'https://dev.bshell.subprod.newlios.toyota.com/remoteEntry.js',
    opershell : 'https://dev.opershell.subprod.newlios.toyota.com/remoteEntry.js',
    operations : 'https://dev.operations.subprod.newlios.toyota.com/remoteEntry.js',
    costplanning : 'https://dev.costplanning.subprod.newlios.toyota.com/remoteEntry.js' 
  },
  TASK_MANAGER: 'https://liosapps.qa.toyota.com/task',
  AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
  ALARMS: 'https://alarms.dev.lios.toyota.com',
  FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
  CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
  COST_PLANNING: 'https://costplanning.dev.lios.toyota.com',
  EBOI: 'https://dev.eboi.subprod.newlios.toyota.com',
  TLD: 'https://liosapps.qa.toyota.com/tld/home',
  DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
  REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
  EXPORT: 'https://liosapps.qa.toyota.com/export',
  GROUPI: 'https://dev.groupi.subprod.newlios.toyota.com',
  SCHEDULE_JOB: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  RETURNS_RELOAD: 'https://ts.stage.portal.toyotasupplier.com/lios/routemgt',
  SCHEDULE_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
  ALLO: 'https://ts.stage.portal.toyotasupplier.com/lios/alloindex#/alloextracts',
  TEMPLATE_URI: "https://template.dev.subprod.newlios.toyota.com"
};
